import clsx from 'clsx';
import type {PortableTextBlock} from 'next-sanity';
import type {SetOptional} from 'type-fest';

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/foundation/components/accordion';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

type Props = {
	title: string;
	items: [
		{
			question: string;
			answer: SetOptional<PortableTextBlock, 'children'>[];
		},
	];
};

export const FAQ = ({title, items}: Props) => {
	return (
		<>
			<h4 className={clsx('font-bold', 'text-[36px]', 'font-display', 'mb-5', 'mt-5')}>
				{title}
			</h4>
			<Accordion type="single" collapsible className="mb-8">
				{items.map((item, idx) => {
					return (
						<AccordionItem key={idx} value={'item-' + idx}>
							<AccordionTrigger>{item.question}</AccordionTrigger>
							<AccordionContent>
								<PortableText value={item.answer} />
							</AccordionContent>
						</AccordionItem>
					);
				})}
			</Accordion>
		</>
	);
};
